module.exports = __webpack_public_path__ + "img/sevenday1-2.8ef528ed.jpg";